import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ISupporterChatRoomListClient,
} from 'interfaceAdapter/gatewaySchemas/ISupporterChatRoomListClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');

export class SupporterChatRoomListClient implements ISupporterChatRoomListClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, companyName } = input;

        const params = new URLSearchParams();
        if (companyName) {
            params.append('company_name', companyName);
        }
        const queryString = params.toString();
        const PATH = `${API_LOCATION_URL}/supporter/chat_rooms${queryString ? `?${queryString}` : ''}`;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-S': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = await fetch(PATH, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
